import type { PropsWithChildren } from 'react';

import VBaseCheckboxRadioGroupContextProvider from './VBaseCheckboxRadioGroupContextProvider';

const VBaseCheckboxRadioGroup = <
  M extends boolean,
  U = M extends true ? string[] : string,
>({
  children,
  defaultValue,
  value,
  onValueChange,
}: PropsWithChildren<{
  defaultValue?: U;
  value?: U;
  onValueChange?: (value: U) => void;
}>) => {
  return (
    <VBaseCheckboxRadioGroupContextProvider<M, U>
      defaultValue={defaultValue}
      value={value}
      onValueChange={onValueChange}
    >
      {children}
    </VBaseCheckboxRadioGroupContextProvider>
  );
};

export default VBaseCheckboxRadioGroup;
